import { toISTInput, fromISTInput } from "../../lib/admin-time";
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useState, useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { useParams, useNavigate, Link } from "react-router-dom";
import { PulseLoader } from "react-spinners";
import { APIContext } from "../../api/api";
import { toast } from "react-toastify";
import { ArrowLeft } from "lucide-react";
import HelmetLayout from "../../components/HelmetLayout";
import {
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Text,
  Box,
  Select,
  ModalCloseButton,
} from "@chakra-ui/react";
import SelectMulti from "react-select";
import { ColorPicker } from "antd";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { PLANS } from "../../plans";

const toDatetimeLocal = toISTInput;

// Helper functions for color conversion
const hexToRgba = (hex) => {
  if (!hex) return { r: 92, g: 189, b: 32, a: 1 };
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})?$/i.exec(hex);
  if (result) {
    return {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16),
      a: result[4] ? parseInt(result[4], 16) / 255 : 1,
    };
  }
  // Try rgba string
  const rgbaMatch = hex.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\)/);
  if (rgbaMatch) {
    return {
      r: parseInt(rgbaMatch[1], 10),
      g: parseInt(rgbaMatch[2], 10),
      b: parseInt(rgbaMatch[3], 10),
      a: rgbaMatch[4] ? parseFloat(rgbaMatch[4]) : 1,
    };
  }
  return { r: 92, g: 189, b: 32, a: 1 };
};

const rgbaToHex = (rgba) => {
  const r = Math.round(rgba.r).toString(16).padStart(2, "0");
  const g = Math.round(rgba.g).toString(16).padStart(2, "0");
  const b = Math.round(rgba.b).toString(16).padStart(2, "0");
  const a = rgba.a < 1 ? Math.round(rgba.a * 255).toString(16).padStart(2, "0") : "";
  return `#${r}${g}${b}${a}`;
};

const rgbaToString = (rgba) => {
  return `rgba(${Math.round(rgba.r)}, ${Math.round(rgba.g)}, ${Math.round(rgba.b)}, ${rgba.a})`;
};

// Convert rgba object to Ant Design color format (rgba string)
const toAntdColor = (rgbaObj) => {
  if (!rgbaObj) return `rgba(92, 189, 32, 1)`;
  return `rgba(${Math.round(rgbaObj.r)}, ${Math.round(rgbaObj.g)}, ${Math.round(rgbaObj.b)}, ${rgbaObj.a})`;
};

function EditBanner({ isNew }) {
  const navigate = useNavigate();
  const { bannerID } = useParams();
  const { getBanner, deleteBanner, createNewBanner, updateBanner } =
    useContext(APIContext);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [loading, setLoading] = useState(true);
  const [isBannerDeleting, setIsBannerDeleting] = useState(false);
  const [isBannerUpdating, setIsBannerUpdating] = useState(false);

  // Banner properties
  const [bannerName, setBannerName] = useState("");
  const [bannerText, setBannerText] = useState("");
  const [bannerColor, setBannerColor] = useState("#5CBD20");
  const [bannerColorRgba, setBannerColorRgba] = useState({ r: 92, g: 189, b: 32, a: 1 });
  const [textColor, setTextColor] = useState("#FFFFFF");
  const [textColorRgba, setTextColorRgba] = useState({ r: 255, g: 255, b: 255, a: 1 });
  const [textAlignment, setTextAlignment] = useState("left");
  const [textMargin, setTextMargin] = useState({ top: 0, right: 0, bottom: 0, left: 0 });
  const [buttonUrl, setButtonUrl] = useState("");
  const [buttonText, setButtonText] = useState("");
  const [buttonColor, setButtonColor] = useState("#FFFFFF");
  const [buttonColorRgba, setButtonColorRgba] = useState({ r: 255, g: 255, b: 255, a: 1 });
  const [buttonTextColor, setButtonTextColor] = useState("#000000");
  const [buttonTextColorRgba, setButtonTextColorRgba] = useState({ r: 0, g: 0, b: 0, a: 1 });
  const [buttonMargin, setButtonMargin] = useState({ top: 0, right: 0, bottom: 0, left: 0 });
  const [buttonPadding, setButtonPadding] = useState({ top: 5, right: 10, bottom: 5, left: 10 });
  const [isDismissable, setIsDismissable] = useState(false);
  const [dismissDays, setDismissDays] = useState(7);
  const [dismissIconColor, setDismissIconColor] = useState("#FFFFFF");
  const [dismissIconColorRgba, setDismissIconColorRgba] = useState({ r: 255, g: 255, b: 255, a: 1 });
  const [startDate, setStartDate] = useState("");
  const [expiryDate, setExpiryDate] = useState("");
  const [published, setPublished] = useState(false);
  const [layout, setLayout] = useState("text-left-button-right");
  const [fontFamily, setFontFamily] = useState("Inter");
  const [textFontSize, setTextFontSize] = useState(14);
  const [buttonFontSize, setButtonFontSize] = useState(14);
  const [gap, setGap] = useState(16);
  const [buttonLayout, setButtonLayout] = useState("filled");
  const [secondaryButtonLayout, setSecondaryButtonLayout] = useState("filled");
  
  // Secondary button properties
  const [secondaryButtonEnabled, setSecondaryButtonEnabled] = useState(false);
  const [secondaryButtonUrl, setSecondaryButtonUrl] = useState("");
  const [secondaryButtonText, setSecondaryButtonText] = useState("");
  const [secondaryButtonColor, setSecondaryButtonColor] = useState("#FFFFFF");
  const [secondaryButtonColorRgba, setSecondaryButtonColorRgba] = useState({ r: 255, g: 255, b: 255, a: 1 });
  const [secondaryButtonTextColor, setSecondaryButtonTextColor] = useState("#000000");
  const [secondaryButtonTextColorRgba, setSecondaryButtonTextColorRgba] = useState({ r: 0, g: 0, b: 0, a: 1 });
  const [secondaryButtonMargin, setSecondaryButtonMargin] = useState({ top: 0, right: 0, bottom: 0, left: 0 });
  const [secondaryButtonPadding, setSecondaryButtonPadding] = useState({ top: 5, right: 10, bottom: 5, left: 10 });

  // Conditions - array of condition objects
  // Each condition (except first) has a "logic" field ("and" or "or") indicating how it combines with the previous condition
  const [conditions, setConditions] = useState([]);

  console.log(startDate, expiryDate);

  useEffect(() => {
    if (!isNew) {
      getBanner(bannerID)
        .then((bannerData) => {
          setBannerName(bannerData.banner_name || "");
          setBannerText(bannerData.banner_text || "");
          const bgColor = bannerData.banner_color || "#5CBD20";
          setBannerColor(bgColor);
          setBannerColorRgba(hexToRgba(bgColor));
          const txtColor = bannerData.text_color || "#FFFFFF";
          setTextColor(txtColor);
          setTextColorRgba(hexToRgba(txtColor));
          setTextAlignment(bannerData.text_alignment || "left");
          setTextMargin(
            bannerData.text_margin 
              ? (typeof bannerData.text_margin === 'object' 
                  ? bannerData.text_margin 
                  : { top: 0, right: 0, bottom: 0, left: 0 })
              : { top: 0, right: 0, bottom: 0, left: 0 }
          );
          const btnColor = bannerData.button_color || "#FFFFFF";
          setButtonColor(btnColor);
          setButtonColorRgba(hexToRgba(btnColor));
          const btnTextColor = bannerData.button_text_color || "#000000";
          setButtonTextColor(btnTextColor);
          setButtonTextColorRgba(hexToRgba(btnTextColor));
          setButtonUrl(bannerData.button_url || "");
          setButtonText(bannerData.button_text || "");
          setButtonMargin(
            bannerData.button_margin 
              ? (typeof bannerData.button_margin === 'object' 
                  ? bannerData.button_margin 
                  : { top: 0, right: 0, bottom: 0, left: 0 })
              : { top: 0, right: 0, bottom: 0, left: 0 }
          );
          setButtonPadding(
            bannerData.button_padding 
              ? (typeof bannerData.button_padding === 'object' 
                  ? bannerData.button_padding 
                  : { top: 5, right: 10, bottom: 5, left: 10 })
              : { top: 5, right: 10, bottom: 5, left: 10 }
          );
          setIsDismissable(bannerData.is_dismissable || false);
          setDismissDays(bannerData.dismiss_days || 7);
          const dismissIconClr = bannerData.dismiss_icon_color || "#FFFFFF";
          setDismissIconColor(dismissIconClr);
          setDismissIconColorRgba(hexToRgba(dismissIconClr));
          setPublished(bannerData.published !== undefined ? bannerData.published : false);
          setLayout(bannerData.layout || "text-left-button-right");
          setFontFamily(bannerData.font_family || "Inter");
          setTextFontSize(bannerData.text_font_size || 14);
          setButtonFontSize(bannerData.button_font_size || 14);
          setGap(bannerData.gap || 16);
          setButtonLayout(bannerData.button_layout || "filled");
          setSecondaryButtonLayout(bannerData.secondary_button_layout || "filled");
          
          // Secondary button data
          setSecondaryButtonEnabled(bannerData.secondary_button_enabled || false);
          setSecondaryButtonUrl(bannerData.secondary_button_url || "");
          setSecondaryButtonText(bannerData.secondary_button_text || "");
          const secBtnColor = bannerData.secondary_button_color || "#FFFFFF";
          setSecondaryButtonColor(secBtnColor);
          setSecondaryButtonColorRgba(hexToRgba(secBtnColor));
          const secBtnTextColor = bannerData.secondary_button_text_color || "#000000";
          setSecondaryButtonTextColor(secBtnTextColor);
          setSecondaryButtonTextColorRgba(hexToRgba(secBtnTextColor));
          setSecondaryButtonMargin(
            bannerData.secondary_button_margin 
              ? (typeof bannerData.secondary_button_margin === 'object' 
                  ? bannerData.secondary_button_margin 
                  : { top: 0, right: 0, bottom: 0, left: 0 })
              : { top: 0, right: 0, bottom: 0, left: 0 }
          );
          setSecondaryButtonPadding(
            bannerData.secondary_button_padding 
              ? (typeof bannerData.secondary_button_padding === 'object' 
                  ? bannerData.secondary_button_padding 
                  : { top: 5, right: 10, bottom: 5, left: 10 })
              : { top: 5, right: 10, bottom: 5, left: 10 }
          );
          
          // Convert timestamp to datetime-local string for input
          if (bannerData.start_date) {
            const date = new Date(bannerData.start_date * 1000);
            setStartDate(toDatetimeLocal(date));
          } else {
            setStartDate("");
          }
          if (bannerData.expiry_date) {
            const date = new Date(bannerData.expiry_date * 1000);
            setExpiryDate(toDatetimeLocal(date));
          } else {
            setExpiryDate("");
          }
          
          // Convert conditions to array format
          // Support both old format (object with email/subscription/last_login) and new format (array)
          if (bannerData.conditions) {
            let conditionsArray = [];
            
            // Check if it's the new array format
            if (Array.isArray(bannerData.conditions)) {
              conditionsArray = bannerData.conditions.map((cond, index) => ({
                id: Date.now() + Math.random() + index,
                type: cond.type || "",
                operator: cond.operator || "",
                value: cond.value || "",
                // Logic operator for combining with previous condition (only for conditions after the first)
                logic: index > 0 ? (cond.logic || "and") : "and", // Default to "and" for UI, but first condition's logic won't be saved
              }));
            } else {
              // Old format: object with email/subscription/last_login
              const logic = bannerData.conditions.logic || "and";
              if (bannerData.conditions.email) {
                conditionsArray.push({
                  id: Date.now() + Math.random(),
                  type: "email",
                  operator: bannerData.conditions.email.operator || "",
                  value: bannerData.conditions.email.value || "",
                  logic: "and", // First condition - logic stored for UI but won't be saved
                });
              }
              if (bannerData.conditions.subscription) {
                const subscriptionValue = bannerData.conditions.subscription.value;
                const valueArray = Array.isArray(subscriptionValue) 
                  ? subscriptionValue 
                  : subscriptionValue ? [subscriptionValue] : [];
                conditionsArray.push({
                  id: Date.now() + Math.random() + conditionsArray.length,
                  type: "subscription",
                  operator: "",
                  value: valueArray,
                  logic: logic, // This condition combines with previous using the logic
                });
              }
              if (bannerData.conditions.last_login) {
                conditionsArray.push({
                  id: Date.now() + Math.random() + conditionsArray.length,
                  type: "last_login",
                  operator: bannerData.conditions.last_login.operator || "",
                  value: bannerData.conditions.last_login.value || "",
                  logic: logic, // This condition combines with previous using the logic
                });
              }
            }
            setConditions(conditionsArray);
          }
          setLoading(false);
        })
        .catch((error) => {
          console.error(error);
          toast.error("Failed to load banner", {
            position: toast.POSITION.TOP_RIGHT,
          });
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, []);

  const addCondition = () => {
    setConditions([
      ...conditions,
      {
        id: Date.now() + Math.random(),
        type: "",
        operator: "",
        value: "", // Will be array for subscription, string for others
        logic: "and", // Default logic operator for combining with previous condition
      },
    ]);
  };

  const removeCondition = (id) => {
    setConditions(conditions.filter((cond) => cond.id !== id));
  };

  const updateCondition = (id, field, value) => {
    setConditions(
      conditions.map((cond) =>
        cond.id === id ? { ...cond, [field]: value } : cond
      )
    );
  };

  // Handle layout change - auto-sets text alignment and button positioning
  const handleLayoutChange = (newLayout) => {
    setLayout(newLayout);
    switch (newLayout) {
      case "text-left-button-right":
        setTextAlignment("left");
        break;
      case "text-center-button-right":
        setTextAlignment("center");
        break;
      case "text-center-button-center":
        setTextAlignment("center");
        break;
      case "text-center-button-left":
        setTextAlignment("center");
        break;
      case "text-center-button-center-left":
        setTextAlignment("center");
        break;
      case "text-center-sideways":
        setTextAlignment("center");
        break;
      default:
        break;
    }
  };

  const handleSave = () => {
    if (isBannerUpdating) {
      return;
    }
    setIsBannerUpdating(true);

    // Convert conditions array to new format (array of condition objects)
    // Each condition (except first) includes its logic operator indicating how it combines with the previous condition
    const validConditions = conditions.filter((cond) => {
      if (!cond.type) return false;
      if (cond.type === "email" && cond.operator && cond.value) return true;
      if (cond.type === "subscription") {
        const subscriptionValues = Array.isArray(cond.value) 
          ? cond.value 
          : cond.value ? [cond.value] : [];
        return subscriptionValues.length > 0;
      }
      if (cond.type === "last_login" && cond.operator && cond.value) return true;
      return false;
    });

    const conditionsArray = validConditions.map((cond, index) => {
      const conditionObj = {
        type: cond.type,
        operator: cond.operator || "",
        value: cond.value || "",
      };
      
      // Handle subscription value as array
      if (cond.type === "subscription") {
        conditionObj.value = Array.isArray(cond.value) 
          ? cond.value 
          : cond.value ? [cond.value] : [];
      }
      
      // Include logic operator for all conditions except the first one
      // The logic indicates how this condition combines with the previous condition
      if (index > 0 && cond.logic) {
        conditionObj.logic = cond.logic;
      }
      
      return conditionObj;
    });

    if ((startDate && !fromISTInput(startDate)) || (expiryDate && !fromISTInput(expiryDate))) {
      toast.error("Please enter a valid IST date and time.");
      return;
    }
    const bannerData = {
      banner_name: bannerName,
      banner_text: bannerText,
      banner_color: rgbaToString(bannerColorRgba),
      text_color: rgbaToString(textColorRgba),
      text_alignment: textAlignment,
      text_margin: textMargin,
      button_url: buttonUrl,
      button_text: buttonText,
      button_color: rgbaToString(buttonColorRgba),
      button_text_color: rgbaToString(buttonTextColorRgba),
      button_margin: buttonMargin,
      button_padding: buttonPadding,
      is_dismissable: isDismissable,
      dismiss_days: dismissDays,
      dismiss_icon_color: rgbaToString(dismissIconColorRgba),
      start_date: startDate ? Math.floor(fromISTInput(startDate).getTime() / 1000) : null,
      expiry_date: expiryDate ? Math.floor(fromISTInput(expiryDate).getTime() / 1000) : null,
      published: published,
      layout: layout,
      font_family: fontFamily,
      text_font_size: textFontSize,
      button_font_size: buttonFontSize,
      gap: gap,
      button_layout: buttonLayout,
      secondary_button_layout: secondaryButtonLayout,
      secondary_button_enabled: secondaryButtonEnabled,
      secondary_button_url: secondaryButtonUrl,
      secondary_button_text: secondaryButtonText,
      secondary_button_color: rgbaToString(secondaryButtonColorRgba),
      secondary_button_text_color: rgbaToString(secondaryButtonTextColorRgba),
      secondary_button_margin: secondaryButtonMargin,
      secondary_button_padding: secondaryButtonPadding,
      conditions: conditionsArray.length > 0 ? conditionsArray : null,
    };

    if (isNew) {
      createNewBanner(bannerData)
        .then((res) => {
          setIsBannerUpdating(false);
          toast.success("Banner created!", {
            position: toast.POSITION.TOP_RIGHT,
          });
          navigate("/banners");
        })
        .catch((error) => {
          console.error(error);
          toast.error("Failed to create banner", {
            position: toast.POSITION.TOP_RIGHT,
          });
          setIsBannerUpdating(false);
        });
    } else {
      updateBanner(bannerID, bannerData)
        .then((res) => {
          setIsBannerUpdating(false);
          toast.success("Banner updated!", {
            position: toast.POSITION.TOP_RIGHT,
          });
        })
        .catch((error) => {
          console.error(error);
          toast.error("Failed to update banner", {
            position: toast.POSITION.TOP_RIGHT,
          });
          setIsBannerUpdating(false);
        });
    }
  };

  const handleDelete = () => {
    if (isBannerDeleting) {
      return;
    }
    setIsBannerDeleting(true);
    deleteBanner(bannerID)
      .then((res) => {
        setIsBannerDeleting(false);
        toast.success("Banner deleted!", {
          position: toast.POSITION.TOP_RIGHT,
        });
        navigate("/banners");
      })
      .catch((error) => {
        console.error(error);
        toast.error("Failed to delete banner", {
          position: toast.POSITION.TOP_RIGHT,
        });
        setIsBannerDeleting(false);
      });
  };

  // Create container for banner preview that prepends to root
  const previewContainerRef = useRef(null);

  useEffect(() => {
    if (typeof document === "undefined") return;

    // Find the root container
    const rootElement = document.getElementById("root");
    if (!rootElement) return;

    // Create container if it doesn't exist
    if (!previewContainerRef.current) {
      const container = document.createElement("div");
      container.id = "banner-preview-container";
      rootElement.insertBefore(container, rootElement.firstChild);
      previewContainerRef.current = container;
    }

    // Cleanup on unmount
    return () => {
      if (previewContainerRef.current && previewContainerRef.current.parentNode) {
        previewContainerRef.current.parentNode.removeChild(previewContainerRef.current);
        previewContainerRef.current = null;
      }
    };
  }, []);

  // Banner Preview Component
  const BannerPreview = () => {
    if (!bannerText && !buttonText && !secondaryButtonText) {
      return null;
    }

    const getTextAlignmentClass = (alignment) => {
      switch (alignment) {
        case "center":
          return "text-center";
        case "right":
          return "text-right";
        case "justify":
          return "text-justify";
        default:
          return "text-left";
      }
    };

    const getLayoutClasses = () => {
      switch (layout) {
        case "text-left-button-right":
          return "flex-row justify-between";
        case "text-center-button-right":
          return "flex-row justify-between";
        case "text-center-button-center":
          return "flex-row justify-center items-center";
        case "text-center-button-left":
          return "flex-row items-center";
        case "text-center-button-center-left":
          return "flex-row-reverse justify-center items-center";
        case "text-center-sideways":
          return "flex-row justify-between items-center";
        default:
          return "flex-row justify-between";
      }
    };

    const getButtonContainerClasses = () => {
      switch (layout) {
        case "text-center-button-center":
          return "flex flex-row gap-2 items-center";
        case "text-center-button-left":
          return "flex flex-row gap-2 items-center";
        case "text-center-button-center-left":
          return "flex flex-row gap-2 items-center";
        case "text-center-sideways":
          return "flex flex-row gap-2 items-center";
        default:
          return "flex flex-row gap-2 items-center";
      }
    };

    const getButtonStyle = (baseStyle) => {
      const style = { ...baseStyle };
      switch (buttonLayout) {
        case "filled":
          // Keep background color as is, ensure border is none
          style.border = "none";
          break;
        case "outline":
          // Only border, no background
          style.backgroundColor = "none";
          style.border = `1px solid ${rgbaToString(buttonColorRgba)}`;
          break;
        case "text":
          // No background, no border
          style.backgroundColor = "none";
          style.border = "none";
          style.textDecoration = "underline";
          break;
        default:
          style.border = "none";
          break;
      }
      return style;
    };

    const getSecondaryButtonStyle = (baseStyle) => {
      const style = { ...baseStyle };
      switch (secondaryButtonLayout) {
        case "filled":
          // Keep background color as is, ensure border is none
          style.border = "none";
          break;
        case "outline":
          // Only border, no background
          style.backgroundColor = "none";
          style.border = `1px solid ${rgbaToString(secondaryButtonColorRgba)}`;
          break;
        case "text":
          // No background, no border
          style.backgroundColor = "none";
          style.border = "none";
          style.textDecoration = "underline";
          break;
        default:
          style.border = "none";
          break;
      }
      return style;
    };

    // Reusable button renderer
    const renderPrimaryButton = () => {
      if (!buttonText || !buttonUrl) return null;
      
      return (
        <a
          href={buttonUrl}
          target="_blank"
          rel="noopener noreferrer"
          className={`px-4 py-2 rounded-[8px] font-medium hover:opacity-90 transition-opacity ${previewStyleId}-button`}
          style={getButtonStyle({ 
            backgroundColor: rgbaToString(buttonColorRgba),
            color: rgbaToString(buttonTextColorRgba),
            fontSize: `${buttonFontSize}px`,
            "--preview-button-margin-top": `${buttonMargin.top}px`,
            "--preview-button-margin-right": `${buttonMargin.right}px`,
            "--preview-button-margin-bottom": `${buttonMargin.bottom}px`,
            "--preview-button-margin-left": `${buttonMargin.left}px`,
            paddingTop: `${buttonPadding.top}px`,
            paddingRight: `${buttonPadding.right}px`,
            paddingBottom: `${buttonPadding.bottom}px`,
            paddingLeft: `${buttonPadding.left}px`
          })}
          onClick={(e) => e.preventDefault()}
        >
          {buttonText}
        </a>
      );
    };

    // Reusable secondary button renderer
    const renderSecondaryButton = () => {
      if (!secondaryButtonEnabled || !secondaryButtonText || !secondaryButtonUrl) return null;
      
      return (
        <a
          href={secondaryButtonUrl}
          target="_blank"
          rel="noopener noreferrer"
          className={`px-4 py-2 rounded-[8px] font-medium hover:opacity-90 transition-opacity ${previewStyleId}-secondary-button`}
          style={getSecondaryButtonStyle({ 
            backgroundColor: rgbaToString(secondaryButtonColorRgba),
            color: rgbaToString(secondaryButtonTextColorRgba),
            fontSize: `${buttonFontSize}px`,
            "--preview-secondary-button-margin-top": `${secondaryButtonMargin.top}px`,
            "--preview-secondary-button-margin-right": `${secondaryButtonMargin.right}px`,
            "--preview-secondary-button-margin-bottom": `${secondaryButtonMargin.bottom}px`,
            "--preview-secondary-button-margin-left": `${secondaryButtonMargin.left}px`,
            paddingTop: `${secondaryButtonPadding.top}px`,
            paddingRight: `${secondaryButtonPadding.right}px`,
            paddingBottom: `${secondaryButtonPadding.bottom}px`,
            paddingLeft: `${secondaryButtonPadding.left}px`
          })}
          onClick={(e) => e.preventDefault()}
        >
          {secondaryButtonText}
        </a>
      );
    };

    const previewStyleId = "banner-preview";

    return (
      <>
        {/* Inject styles for desktop-only margins */}
        <style>
          {`
            @media (min-width: 768px) {
              .${previewStyleId}-text {
                margin-top: var(--preview-text-margin-top, 0);
                margin-right: var(--preview-text-margin-right, 0);
                margin-bottom: var(--preview-text-margin-bottom, 0);
                margin-left: var(--preview-text-margin-left, 0);
              }
              .${previewStyleId}-button {
                margin-top: var(--preview-button-margin-top, 0);
                margin-right: var(--preview-button-margin-right, 0);
                margin-bottom: var(--preview-button-margin-bottom, 0);
                margin-left: var(--preview-button-margin-left, 0);
              }
              .${previewStyleId}-secondary-button {
                margin-top: var(--preview-secondary-button-margin-top, 0);
                margin-right: var(--preview-secondary-button-margin-right, 0);
                margin-bottom: var(--preview-secondary-button-margin-bottom, 0);
                margin-left: var(--preview-secondary-button-margin-left, 0);
              }
            }
          `}
        </style>
        <div
          className={`w-full flex items-center py-[4px] relative ${getLayoutClasses()}`}
          style={{ 
            backgroundColor: rgbaToString(bannerColorRgba),
            fontFamily: fontFamily,
            gap: `${gap}px`,
            paddingLeft: "16px",
            paddingRight: isDismissable ? "calc(16px + 40px)" : "16px"
          }}
        >
          {layout === "text-center-button-left" && (
            <div className={getButtonContainerClasses()}>
              {renderPrimaryButton()}
              {renderSecondaryButton()}
            </div>
          )}
          {layout === "text-center-sideways" && (
            <div className={getButtonContainerClasses()}>
              {renderSecondaryButton()}
            </div>
          )}
          <div 
            className={`font-medium ${(layout === "text-center-button-center" || layout === "text-center-sideways" || layout === "text-center-button-center-left") ? "" : "flex-1"} ${getTextAlignmentClass(textAlignment)} ${previewStyleId}-text`}
            style={{ 
              color: rgbaToString(textColorRgba),
              fontSize: `${textFontSize}px`,
              "--preview-text-margin-top": `${textMargin.top}px`,
              "--preview-text-margin-right": `${textMargin.right}px`,
              "--preview-text-margin-bottom": `${textMargin.bottom}px`,
              "--preview-text-margin-left": `${textMargin.left}px`
            }}
            dangerouslySetInnerHTML={{ __html: bannerText || "Banner text preview" }}
          />
          {(layout === "text-center-button-center" || layout === "text-center-button-center-left") && (
            <div className={getButtonContainerClasses()}>
              {renderPrimaryButton()}
              {renderSecondaryButton()}
            </div>
          )}
          {layout !== "text-center-button-left" && layout !== "text-center-button-center" && layout !== "text-center-button-center-left" && layout !== "text-center-sideways" && (
            <div className={getButtonContainerClasses()}>
              {renderPrimaryButton()}
              {renderSecondaryButton()}
            </div>
          )}
          {layout === "text-center-sideways" && (
            <div className={getButtonContainerClasses()}>
              {renderPrimaryButton()}
            </div>
          )}
          {isDismissable && (
            <button 
              className="absolute right-4 top-1/2 -translate-y-1/2 px-3 flex py-[4px] text-sm hover:bg-black/20 rounded transition-colors z-10"
              style={{ color: rgbaToString(dismissIconColorRgba) }}
              onClick={(e) => e.preventDefault()}
            >
              ×
            </button>
          )}
        </div>
      </>
    );
  };

  return (
    <>
      <HelmetLayout title={isNew ? "New Banner" : `Edit Banner`} />
      {/* Banner Preview Portal - Prepends to body */}
      {previewContainerRef.current &&
        createPortal(<BannerPreview />, previewContainerRef.current)}
      {!loading && (
        <div className="space-y-6 pb-16 max-w-6xl">
          <div>
            <Link target="_blank" rel="noopener noreferrer"
              to="/banners"
              className="inline-flex items-center gap-1.5 text-xs font-semibold text-slate-500 hover:text-slate-800 transition-colors mb-2"
            >
              <ArrowLeft size={14} />
              Back to Banners
            </Link>
            <h1 className="text-2xl font-bold text-slate-900">
              {isNew ? "New Banner" : "Edit Banner"}
            </h1>
          </div>

            {/* Preview Info */}
            <div className="w-full mb-6">
              <h2 className="text-xl font-semibold mb-3">Preview</h2>
              <p className="text-sm text-gray-600 mb-2">
                The banner preview is displayed at the top of your screen. Update the fields below to see changes in real-time.
              </p>
              {!bannerText && !buttonText && !secondaryButtonText && (
                <p className="text-sm text-gray-500 italic">
                  Add banner text or button text to see the preview
                </p>
              )}
            </div>

            <div className="w-full max-w-6xl flex flex-col justify-start p-7 gap-y-4">
              {/* Basic Info - Full Width */}
              <div className="w-full">
                <label
                  htmlFor="banner_name"
                  className="block text-sm text-[#121212] font-medium mb-1.5"
                >
                  Banner Name (Internal)
                </label>
                <input
                  id="banner_name"
                  value={bannerName}
                  onChange={(e) => setBannerName(e.target.value)}
                  className="block w-full placeholder-gray-400/70 rounded-xl bg-white px-4 py-2 text-gray-700 shadow-input-tag text-sm"
                  placeholder="Enter banner name for internal purposes"
                />
              </div>

              {/* Banner Text - Rich Text Editor - Full Width */}
              <div className="w-full">
                <label
                  htmlFor="banner_text"
                  className="block text-sm text-[#121212] font-medium mb-1.5"
                >
                  Banner Text
                </label>
                <div className="overflow-hidden">
                  <ReactQuill
                    theme="snow"
                    value={bannerText}
                    onChange={setBannerText}
                    placeholder="Enter banner text"
                    style={{ minHeight: "120px" }}
                  />
                </div>
              </div>

              {/* Two Column Layout for Settings */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full">
                {/* Left Column */}
                <div className="flex flex-col gap-4">
                  {/* Text Settings Section */}
                  <div className="bg-gray-50 rounded-xl p-4 border border-gray-200">
                    <h3 className="text-base font-semibold text-[#121212] mb-3">Text Settings</h3>
                    
                    {/* Layout Setting */}
                    <div className="mb-3">
                      <label
                        htmlFor="layout"
                        className="block text-sm text-[#121212] font-medium mb-1.5"
                      >
                        Layout
                      </label>
                      <Select
                        id="layout"
                        value={layout}
                        onChange={(e) => handleLayoutChange(e.target.value)}
                        size="sm"
                      >
                        <option value="text-left-button-right">Text Left Button Right</option>
                        <option value="text-center-button-right">Text Center Button Right</option>
                        <option value="text-center-button-center">Text Center Button Center</option>
                        <option value="text-center-button-left">Text Center Button Left</option>
                        <option value="text-center-button-center-left">Text Center Button Center (Button on left)</option>
                        <option value="text-center-sideways">Text Center Sideways button</option>
                      </Select>
                    </div>

                    {/* Font Family */}
                    <div className="mb-3">
                      <label
                        htmlFor="font_family"
                        className="block text-sm text-[#121212] font-medium mb-1.5"
                      >
                        Font Family
                      </label>
                      <Select
                        id="font_family"
                        value={fontFamily}
                        onChange={(e) => setFontFamily(e.target.value)}
                        size="sm"
                      >
                        <option value="Inter">Inter</option>
                        <option value="Helvetica">Helvetica</option>
                        <option value="Arial">Arial</option>
                        <option value="Verdana">Verdana</option>
                        <option value="Georgia">Georgia</option>
                        <option value="Times New Roman">Times New Roman</option>
                        <option value="Open Sans">Open Sans</option>
                        <option value="Lato">Lato</option>
                      </Select>
                    </div>

                    {/* Text Font Size */}
                    <div className="mb-3">
                      <label
                        htmlFor="text_font_size"
                        className="block text-sm text-[#121212] font-medium mb-1.5"
                      >
                        Text Font Size (px)
                      </label>
                      <input
                        id="text_font_size"
                        type="number"
                        min="8"
                        max="72"
                        value={textFontSize}
                        onChange={(e) => setTextFontSize(parseInt(e.target.value) || 14)}
                        className="block w-full placeholder-gray-400/70 rounded-xl bg-white px-4 py-2 text-gray-700 shadow-input-tag text-sm"
                        placeholder="14"
                      />
                    </div>

                    {/* Gap */}
                    <div className="mb-3">
                      <label
                        htmlFor="gap"
                        className="block text-sm text-[#121212] font-medium mb-1.5"
                      >
                        Gap (px)
                      </label>
                      <input
                        id="gap"
                        type="number"
                        min="0"
                        max="100"
                        value={gap}
                        onChange={(e) => setGap(parseInt(e.target.value) || 16)}
                        className="block w-full placeholder-gray-400/70 rounded-xl bg-white px-4 py-2 text-gray-700 shadow-input-tag text-sm"
                        placeholder="16"
                      />
                      <p className="text-xs text-gray-500 mt-1">
                        Spacing between text and buttons
                      </p>
                    </div>

                    {/* Text Color */}
                    <div className="mb-3">
                      <label className="block text-sm text-[#121212] font-medium mb-1.5">
                        Text Color
                      </label>
                      <div className="flex flex-row gap-2 items-center w-full rounded-xl bg-white px-3 py-2 shadow-input-tag border border-gray-200">
                        <ColorPicker
                          value={toAntdColor(textColorRgba)}
                          onChange={(color) => {
                            const rgb = color.toRgb ? color.toRgb() : { r: 255, g: 255, b: 255, a: 1 };
                            const rgba = {
                              r: rgb.r,
                              g: rgb.g,
                              b: rgb.b,
                              a: rgb.a !== undefined ? rgb.a : 1,
                            };
                            setTextColorRgba(rgba);
                            setTextColor(color.toHexString ? color.toHexString() : "#FFFFFF");
                          }}
                          showText
                          format="rgba"
                          size="small"
                          presets={[
                            {
                              label: "Presets",
                              colors: [
                                "rgba(255, 255, 255, 1)",
                                "rgba(0, 0, 0, 1)",
                                "rgba(92, 189, 32, 1)",
                                "rgba(255, 0, 0, 1)",
                                "rgba(0, 255, 0, 1)",
                                "rgba(0, 0, 255, 1)",
                              ],
                            },
                          ]}
                        />
                        <span className="text-xs text-gray-600 flex-1 text-left">
                          {rgbaToString(textColorRgba)}
                        </span>
                      </div>
                    </div>

                    {/* Text Margin */}
                    <div>
                      <label className="block text-sm text-[#121212] font-medium mb-1.5">
                        Text Margin (px)
                      </label>
                      <div className="grid grid-cols-4 gap-2">
                        <div>
                          <label className="block text-xs text-gray-600 mb-1">Top</label>
                          <input
                            type="number"
                            value={textMargin.top}
                            onChange={(e) => setTextMargin({ ...textMargin, top: parseInt(e.target.value) || 0 })}
                            className="block w-full placeholder-gray-400/70 rounded-xl bg-white px-3 py-1.5 text-gray-700 shadow-input-tag text-sm"
                            placeholder="0"
                          />
                        </div>
                        <div>
                          <label className="block text-xs text-gray-600 mb-1">Right</label>
                          <input
                            type="number"
                            value={textMargin.right}
                            onChange={(e) => setTextMargin({ ...textMargin, right: parseInt(e.target.value) || 0 })}
                            className="block w-full placeholder-gray-400/70 rounded-xl bg-white px-3 py-1.5 text-gray-700 shadow-input-tag text-sm"
                            placeholder="0"
                          />
                        </div>
                        <div>
                          <label className="block text-xs text-gray-600 mb-1">Bottom</label>
                          <input
                            type="number"
                            value={textMargin.bottom}
                            onChange={(e) => setTextMargin({ ...textMargin, bottom: parseInt(e.target.value) || 0 })}
                            className="block w-full placeholder-gray-400/70 rounded-xl bg-white px-3 py-1.5 text-gray-700 shadow-input-tag text-sm"
                            placeholder="0"
                          />
                        </div>
                        <div>
                          <label className="block text-xs text-gray-600 mb-1">Left</label>
                          <input
                            type="number"
                            value={textMargin.left}
                            onChange={(e) => setTextMargin({ ...textMargin, left: parseInt(e.target.value) || 0 })}
                            className="block w-full placeholder-gray-400/70 rounded-xl bg-white px-3 py-1.5 text-gray-700 shadow-input-tag text-sm"
                            placeholder="0"
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Button Settings Section */}
                  <div className="bg-gray-50 rounded-xl p-4 border border-gray-200">
                    <h3 className="text-base font-semibold text-[#121212] mb-3">Button Settings</h3>
                    
                    {/* Button URL */}
                    <div className="mb-3">
                      <label
                        htmlFor="button_url"
                        className="block text-sm text-[#121212] font-medium mb-1.5"
                      >
                        Button URL
                      </label>
                      <input
                        id="button_url"
                        value={buttonUrl}
                        onChange={(e) => setButtonUrl(e.target.value)}
                        className="block w-full placeholder-gray-400/70 rounded-xl bg-white px-4 py-2 text-gray-700 shadow-input-tag text-sm"
                        placeholder="https://example.com"
                      />
                    </div>

                    {/* Button Text */}
                    <div className="mb-3">
                      <label
                        htmlFor="button_text"
                        className="block text-sm text-[#121212] font-medium mb-1.5"
                      >
                        Button Text
                      </label>
                      <input
                        id="button_text"
                        value={buttonText}
                        onChange={(e) => setButtonText(e.target.value)}
                        className="block w-full placeholder-gray-400/70 rounded-xl bg-white px-4 py-2 text-gray-700 shadow-input-tag text-sm"
                        placeholder="Click Here"
                      />
                    </div>

                    {/* Button Font Size */}
                    <div className="mb-3">
                      <label
                        htmlFor="button_font_size"
                        className="block text-sm text-[#121212] font-medium mb-1.5"
                      >
                        Button Font Size (px)
                      </label>
                      <input
                        id="button_font_size"
                        type="number"
                        min="8"
                        max="72"
                        value={buttonFontSize}
                        onChange={(e) => setButtonFontSize(parseInt(e.target.value) || 14)}
                        className="block w-full placeholder-gray-400/70 rounded-xl bg-white px-4 py-2 text-gray-700 shadow-input-tag text-sm"
                        placeholder="14"
                      />
                    </div>

                    {/* Button Layout */}
                    <div className="mb-3">
                      <label
                        htmlFor="button_layout"
                        className="block text-sm text-[#121212] font-medium mb-1.5"
                      >
                        Button Layout
                      </label>
                      <Select
                        id="button_layout"
                        value={buttonLayout}
                        onChange={(e) => setButtonLayout(e.target.value)}
                        size="sm"
                      >
                        <option value="filled">Filled</option>
                        <option value="outline">Outline</option>
                        <option value="text">Text</option>
                      </Select>
                    </div>

                    {/* Button Background Color */}
                    <div className="mb-3">
                      <label className="block text-sm text-[#121212] font-medium mb-1.5">
                        Button Background Color
                      </label>
                      <div className="flex flex-row gap-2 items-center w-full rounded-xl bg-white px-3 py-2 shadow-input-tag border border-gray-200">
                        <ColorPicker
                          value={toAntdColor(buttonColorRgba)}
                          onChange={(color) => {
                            const rgb = color.toRgb ? color.toRgb() : { r: 255, g: 255, b: 255, a: 1 };
                            const rgba = {
                              r: rgb.r,
                              g: rgb.g,
                              b: rgb.b,
                              a: rgb.a !== undefined ? rgb.a : 1,
                            };
                            setButtonColorRgba(rgba);
                            setButtonColor(color.toHexString ? color.toHexString() : "#FFFFFF");
                          }}
                          showText
                          format="rgba"
                          size="small"
                          presets={[
                            {
                              label: "Presets",
                              colors: [
                                "rgba(255, 255, 255, 1)",
                                "rgba(92, 189, 32, 1)",
                                "rgba(0, 0, 0, 1)",
                                "rgba(255, 0, 0, 1)",
                                "rgba(0, 255, 0, 1)",
                                "rgba(0, 0, 255, 1)",
                              ],
                            },
                          ]}
                        />
                        <span className="text-xs text-gray-600 flex-1 text-left">
                          {rgbaToString(buttonColorRgba)}
                        </span>
                      </div>
                    </div>

                    {/* Button Text Color */}
                    <div className="mb-3">
                      <label className="block text-sm text-[#121212] font-medium mb-1.5">
                        Button Text Color
                      </label>
                      <div className="flex flex-row gap-2 items-center w-full rounded-xl bg-white px-3 py-2 shadow-input-tag border border-gray-200">
                        <ColorPicker
                          value={toAntdColor(buttonTextColorRgba)}
                          onChange={(color) => {
                            const rgb = color.toRgb ? color.toRgb() : { r: 0, g: 0, b: 0, a: 1 };
                            const rgba = {
                              r: rgb.r,
                              g: rgb.g,
                              b: rgb.b,
                              a: rgb.a !== undefined ? rgb.a : 1,
                            };
                            setButtonTextColorRgba(rgba);
                            setButtonTextColor(color.toHexString ? color.toHexString() : "#000000");
                          }}
                          showText
                          format="rgba"
                          size="small"
                          presets={[
                            {
                              label: "Presets",
                              colors: [
                                "rgba(0, 0, 0, 1)",
                                "rgba(255, 255, 255, 1)",
                                "rgba(92, 189, 32, 1)",
                                "rgba(255, 0, 0, 1)",
                                "rgba(0, 255, 0, 1)",
                                "rgba(0, 0, 255, 1)",
                              ],
                            },
                          ]}
                        />
                        <span className="text-xs text-gray-600 flex-1 text-left">
                          {rgbaToString(buttonTextColorRgba)}
                        </span>
                      </div>
                    </div>

                    {/* Button Margin */}
                    <div className="mb-3">
                      <label className="block text-sm text-[#121212] font-medium mb-1.5">
                        Button Margin (px)
                      </label>
                      <div className="grid grid-cols-4 gap-2">
                        <div>
                          <label className="block text-xs text-gray-600 mb-1">Top</label>
                          <input
                            type="number"
                            value={buttonMargin.top}
                            onChange={(e) => setButtonMargin({ ...buttonMargin, top: parseInt(e.target.value) || 0 })}
                            className="block w-full placeholder-gray-400/70 rounded-xl bg-white px-3 py-1.5 text-gray-700 shadow-input-tag text-sm"
                            placeholder="0"
                          />
                        </div>
                        <div>
                          <label className="block text-xs text-gray-600 mb-1">Right</label>
                          <input
                            type="number"
                            value={buttonMargin.right}
                            onChange={(e) => setButtonMargin({ ...buttonMargin, right: parseInt(e.target.value) || 0 })}
                            className="block w-full placeholder-gray-400/70 rounded-xl bg-white px-3 py-1.5 text-gray-700 shadow-input-tag text-sm"
                            placeholder="0"
                          />
                        </div>
                        <div>
                          <label className="block text-xs text-gray-600 mb-1">Bottom</label>
                          <input
                            type="number"
                            value={buttonMargin.bottom}
                            onChange={(e) => setButtonMargin({ ...buttonMargin, bottom: parseInt(e.target.value) || 0 })}
                            className="block w-full placeholder-gray-400/70 rounded-xl bg-white px-3 py-1.5 text-gray-700 shadow-input-tag text-sm"
                            placeholder="0"
                          />
                        </div>
                        <div>
                          <label className="block text-xs text-gray-600 mb-1">Left</label>
                          <input
                            type="number"
                            value={buttonMargin.left}
                            onChange={(e) => setButtonMargin({ ...buttonMargin, left: parseInt(e.target.value) || 0 })}
                            className="block w-full placeholder-gray-400/70 rounded-xl bg-white px-3 py-1.5 text-gray-700 shadow-input-tag text-sm"
                            placeholder="0"
                          />
                        </div>
                      </div>
                    </div>

                    {/* Button Padding */}
                    <div>
                      <label className="block text-sm text-[#121212] font-medium mb-1.5">
                        Button Padding (px)
                      </label>
                      <div className="grid grid-cols-4 gap-2">
                        <div>
                          <label className="block text-xs text-gray-600 mb-1">Top</label>
                          <input
                            type="number"
                            value={buttonPadding.top}
                            onChange={(e) => setButtonPadding({ ...buttonPadding, top: parseInt(e.target.value) || 0 })}
                            className="block w-full placeholder-gray-400/70 rounded-xl bg-white px-3 py-1.5 text-gray-700 shadow-input-tag text-sm"
                            placeholder="0"
                          />
                        </div>
                        <div>
                          <label className="block text-xs text-gray-600 mb-1">Right</label>
                          <input
                            type="number"
                            value={buttonPadding.right}
                            onChange={(e) => setButtonPadding({ ...buttonPadding, right: parseInt(e.target.value) || 0 })}
                            className="block w-full placeholder-gray-400/70 rounded-xl bg-white px-3 py-1.5 text-gray-700 shadow-input-tag text-sm"
                            placeholder="0"
                          />
                        </div>
                        <div>
                          <label className="block text-xs text-gray-600 mb-1">Bottom</label>
                          <input
                            type="number"
                            value={buttonPadding.bottom}
                            onChange={(e) => setButtonPadding({ ...buttonPadding, bottom: parseInt(e.target.value) || 0 })}
                            className="block w-full placeholder-gray-400/70 rounded-xl bg-white px-3 py-1.5 text-gray-700 shadow-input-tag text-sm"
                            placeholder="0"
                          />
                        </div>
                        <div>
                          <label className="block text-xs text-gray-600 mb-1">Left</label>
                          <input
                            type="number"
                            value={buttonPadding.left}
                            onChange={(e) => setButtonPadding({ ...buttonPadding, left: parseInt(e.target.value) || 0 })}
                            className="block w-full placeholder-gray-400/70 rounded-xl bg-white px-3 py-1.5 text-gray-700 shadow-input-tag text-sm"
                            placeholder="0"
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Secondary Button Settings Section */}
                  <div className="bg-gray-50 rounded-xl p-4 border border-gray-200">
                    <h3 className="text-base font-semibold text-[#121212] mb-3">Secondary Button Settings</h3>
                    
                    {/* Enable Secondary Button */}
                    <div className="mb-3">
                      <label className="flex items-center gap-2">
                        <input
                          type="checkbox"
                          checked={secondaryButtonEnabled}
                          onChange={(e) => setSecondaryButtonEnabled(e.target.checked)}
                          className="w-4 h-4 rounded"
                        />
                        <span className="text-sm text-[#121212] font-medium">
                          Enable Secondary Button
                        </span>
                      </label>
                    </div>

                    {secondaryButtonEnabled && (
                      <>
                        {/* Secondary Button URL */}
                        <div className="mb-3">
                          <label
                            htmlFor="secondary_button_url"
                            className="block text-sm text-[#121212] font-medium mb-1.5"
                          >
                            Secondary Button URL
                          </label>
                          <input
                            id="secondary_button_url"
                            value={secondaryButtonUrl}
                            onChange={(e) => setSecondaryButtonUrl(e.target.value)}
                            className="block w-full placeholder-gray-400/70 rounded-xl bg-white px-4 py-2 text-gray-700 shadow-input-tag text-sm"
                            placeholder="https://example.com"
                          />
                        </div>

                        {/* Secondary Button Text */}
                        <div className="mb-3">
                          <label
                            htmlFor="secondary_button_text"
                            className="block text-sm text-[#121212] font-medium mb-1.5"
                          >
                            Secondary Button Text
                          </label>
                          <input
                            id="secondary_button_text"
                            value={secondaryButtonText}
                            onChange={(e) => setSecondaryButtonText(e.target.value)}
                            className="block w-full placeholder-gray-400/70 rounded-xl bg-white px-4 py-2 text-gray-700 shadow-input-tag text-sm"
                            placeholder="Click Here"
                          />
                        </div>

                        {/* Secondary Button Background Color */}
                        <div className="mb-3">
                          <label className="block text-sm text-[#121212] font-medium mb-1.5">
                            Secondary Button Background Color
                          </label>
                          <div className="flex flex-row gap-2 items-center w-full rounded-xl bg-white px-3 py-2 shadow-input-tag border border-gray-200">
                            <ColorPicker
                              value={toAntdColor(secondaryButtonColorRgba)}
                              onChange={(color) => {
                                const rgb = color.toRgb ? color.toRgb() : { r: 255, g: 255, b: 255, a: 1 };
                                const rgba = {
                                  r: rgb.r,
                                  g: rgb.g,
                                  b: rgb.b,
                                  a: rgb.a !== undefined ? rgb.a : 1,
                                };
                                setSecondaryButtonColorRgba(rgba);
                                setSecondaryButtonColor(color.toHexString ? color.toHexString() : "#FFFFFF");
                              }}
                              showText
                              format="rgba"
                              size="small"
                              presets={[
                                {
                                  label: "Presets",
                                  colors: [
                                    "rgba(255, 255, 255, 1)",
                                    "rgba(92, 189, 32, 1)",
                                    "rgba(0, 0, 0, 1)",
                                    "rgba(255, 0, 0, 1)",
                                    "rgba(0, 255, 0, 1)",
                                    "rgba(0, 0, 255, 1)",
                                  ],
                                },
                              ]}
                            />
                            <span className="text-xs text-gray-600 flex-1 text-left">
                              {rgbaToString(secondaryButtonColorRgba)}
                            </span>
                          </div>
                        </div>

                        {/* Secondary Button Text Color */}
                        <div className="mb-3">
                          <label className="block text-sm text-[#121212] font-medium mb-1.5">
                            Secondary Button Text Color
                          </label>
                          <div className="flex flex-row gap-2 items-center w-full rounded-xl bg-white px-3 py-2 shadow-input-tag border border-gray-200">
                            <ColorPicker
                              value={toAntdColor(secondaryButtonTextColorRgba)}
                              onChange={(color) => {
                                const rgb = color.toRgb ? color.toRgb() : { r: 0, g: 0, b: 0, a: 1 };
                                const rgba = {
                                  r: rgb.r,
                                  g: rgb.g,
                                  b: rgb.b,
                                  a: rgb.a !== undefined ? rgb.a : 1,
                                };
                                setSecondaryButtonTextColorRgba(rgba);
                                setSecondaryButtonTextColor(color.toHexString ? color.toHexString() : "#000000");
                              }}
                              showText
                              format="rgba"
                              size="small"
                              presets={[
                                {
                                  label: "Presets",
                                  colors: [
                                    "rgba(0, 0, 0, 1)",
                                    "rgba(255, 255, 255, 1)",
                                    "rgba(92, 189, 32, 1)",
                                    "rgba(255, 0, 0, 1)",
                                    "rgba(0, 255, 0, 1)",
                                    "rgba(0, 0, 255, 1)",
                                  ],
                                },
                              ]}
                            />
                            <span className="text-xs text-gray-600 flex-1 text-left">
                              {rgbaToString(secondaryButtonTextColorRgba)}
                            </span>
                          </div>
                        </div>

                        {/* Secondary Button Layout */}
                        <div className="mb-3">
                          <label
                            htmlFor="secondary_button_layout"
                            className="block text-sm text-[#121212] font-medium mb-1.5"
                          >
                            Secondary Button Layout
                          </label>
                          <Select
                            id="secondary_button_layout"
                            value={secondaryButtonLayout}
                            onChange={(e) => setSecondaryButtonLayout(e.target.value)}
                            size="sm"
                          >
                            <option value="filled">Filled</option>
                            <option value="outline">Outline</option>
                            <option value="text">Text</option>
                          </Select>
                        </div>

                        {/* Secondary Button Margin */}
                        <div className="mb-3">
                          <label className="block text-sm text-[#121212] font-medium mb-1.5">
                            Secondary Button Margin (px)
                          </label>
                          <div className="grid grid-cols-4 gap-2">
                            <div>
                              <label className="block text-xs text-gray-600 mb-1">Top</label>
                              <input
                                type="number"
                                value={secondaryButtonMargin.top}
                                onChange={(e) => setSecondaryButtonMargin({ ...secondaryButtonMargin, top: parseInt(e.target.value) || 0 })}
                                className="block w-full placeholder-gray-400/70 rounded-xl bg-white px-3 py-1.5 text-gray-700 shadow-input-tag text-sm"
                                placeholder="0"
                              />
                            </div>
                            <div>
                              <label className="block text-xs text-gray-600 mb-1">Right</label>
                              <input
                                type="number"
                                value={secondaryButtonMargin.right}
                                onChange={(e) => setSecondaryButtonMargin({ ...secondaryButtonMargin, right: parseInt(e.target.value) || 0 })}
                                className="block w-full placeholder-gray-400/70 rounded-xl bg-white px-3 py-1.5 text-gray-700 shadow-input-tag text-sm"
                                placeholder="0"
                              />
                            </div>
                            <div>
                              <label className="block text-xs text-gray-600 mb-1">Bottom</label>
                              <input
                                type="number"
                                value={secondaryButtonMargin.bottom}
                                onChange={(e) => setSecondaryButtonMargin({ ...secondaryButtonMargin, bottom: parseInt(e.target.value) || 0 })}
                                className="block w-full placeholder-gray-400/70 rounded-xl bg-white px-3 py-1.5 text-gray-700 shadow-input-tag text-sm"
                                placeholder="0"
                              />
                            </div>
                            <div>
                              <label className="block text-xs text-gray-600 mb-1">Left</label>
                              <input
                                type="number"
                                value={secondaryButtonMargin.left}
                                onChange={(e) => setSecondaryButtonMargin({ ...secondaryButtonMargin, left: parseInt(e.target.value) || 0 })}
                                className="block w-full placeholder-gray-400/70 rounded-xl bg-white px-3 py-1.5 text-gray-700 shadow-input-tag text-sm"
                                placeholder="0"
                              />
                            </div>
                          </div>
                        </div>

                        {/* Secondary Button Padding */}
                        <div>
                          <label className="block text-sm text-[#121212] font-medium mb-1.5">
                            Secondary Button Padding (px)
                          </label>
                          <div className="grid grid-cols-4 gap-2">
                            <div>
                              <label className="block text-xs text-gray-600 mb-1">Top</label>
                              <input
                                type="number"
                                value={secondaryButtonPadding.top}
                                onChange={(e) => setSecondaryButtonPadding({ ...secondaryButtonPadding, top: parseInt(e.target.value) || 0 })}
                                className="block w-full placeholder-gray-400/70 rounded-xl bg-white px-3 py-1.5 text-gray-700 shadow-input-tag text-sm"
                                placeholder="0"
                              />
                            </div>
                            <div>
                              <label className="block text-xs text-gray-600 mb-1">Right</label>
                              <input
                                type="number"
                                value={secondaryButtonPadding.right}
                                onChange={(e) => setSecondaryButtonPadding({ ...secondaryButtonPadding, right: parseInt(e.target.value) || 0 })}
                                className="block w-full placeholder-gray-400/70 rounded-xl bg-white px-3 py-1.5 text-gray-700 shadow-input-tag text-sm"
                                placeholder="0"
                              />
                            </div>
                            <div>
                              <label className="block text-xs text-gray-600 mb-1">Bottom</label>
                              <input
                                type="number"
                                value={secondaryButtonPadding.bottom}
                                onChange={(e) => setSecondaryButtonPadding({ ...secondaryButtonPadding, bottom: parseInt(e.target.value) || 0 })}
                                className="block w-full placeholder-gray-400/70 rounded-xl bg-white px-3 py-1.5 text-gray-700 shadow-input-tag text-sm"
                                placeholder="0"
                              />
                            </div>
                            <div>
                              <label className="block text-xs text-gray-600 mb-1">Left</label>
                              <input
                                type="number"
                                value={secondaryButtonPadding.left}
                                onChange={(e) => setSecondaryButtonPadding({ ...secondaryButtonPadding, left: parseInt(e.target.value) || 0 })}
                                className="block w-full placeholder-gray-400/70 rounded-xl bg-white px-3 py-1.5 text-gray-700 shadow-input-tag text-sm"
                                placeholder="0"
                              />
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>

                {/* Right Column */}
                <div className="flex flex-col gap-4">
                  {/* Banner Settings Section */}
                  <div className="bg-gray-50 rounded-xl p-4 border border-gray-200">
                    <h3 className="text-base font-semibold text-[#121212] mb-3">Banner Settings</h3>
                    
                    {/* Banner Background Color */}
                    <div className="mb-3">
                      <label className="block text-sm text-[#121212] font-medium mb-1.5">
                        Banner Background Color
                      </label>
                      <div className="flex flex-row gap-2 items-center w-full rounded-xl bg-white px-3 py-2 shadow-input-tag border border-gray-200">
                        <ColorPicker
                          value={toAntdColor(bannerColorRgba)}
                          onChange={(color) => {
                            const rgb = color.toRgb ? color.toRgb() : { r: 92, g: 189, b: 32, a: 1 };
                            const rgba = {
                              r: rgb.r,
                              g: rgb.g,
                              b: rgb.b,
                              a: rgb.a !== undefined ? rgb.a : 1,
                            };
                            setBannerColorRgba(rgba);
                            setBannerColor(color.toHexString ? color.toHexString() : "#5CBD20");
                          }}
                          showText
                          format="rgba"
                          size="small"
                          presets={[
                            {
                              label: "Presets",
                              colors: [
                                "rgba(92, 189, 32, 1)",
                                "rgba(255, 255, 255, 1)",
                                "rgba(0, 0, 0, 1)",
                                "rgba(255, 0, 0, 1)",
                                "rgba(0, 255, 0, 1)",
                                "rgba(0, 0, 255, 1)",
                              ],
                            },
                          ]}
                        />
                        <span className="text-xs text-gray-600 flex-1 text-left">
                          {rgbaToString(bannerColorRgba)}
                        </span>
                      </div>
                    </div>

                    {/* Is Dismissable */}
                    <div className="mb-3">
                      <label className="flex items-center gap-2">
                        <input
                          type="checkbox"
                          checked={isDismissable}
                          onChange={(e) => setIsDismissable(e.target.checked)}
                          className="w-4 h-4 rounded"
                        />
                        <span className="text-sm text-[#121212] font-medium">
                          Is Dismissable
                        </span>
                      </label>
                    </div>

                    {/* Dismiss Days */}
                    {isDismissable && (
                      <>
                        <div className="mb-3">
                          <label
                            htmlFor="dismiss_days"
                            className="block text-sm text-[#121212] font-medium mb-1.5"
                          >
                            Dismiss for how many days?
                          </label>
                          <input
                            id="dismiss_days"
                            type="number"
                            min="1"
                            value={dismissDays}
                            onChange={(e) => setDismissDays(parseInt(e.target.value) || 7)}
                            className="block w-full placeholder-gray-400/70 rounded-xl bg-white px-4 py-2 text-gray-700 shadow-input-tag text-sm"
                          />
                        </div>
                        {/* Dismiss Icon Color */}
                        <div className="mb-3">
                          <label className="block text-sm text-[#121212] font-medium mb-1.5">
                            Dismiss Icon Color
                          </label>
                          <div className="flex flex-row gap-2 items-center w-full rounded-xl bg-white px-3 py-2 shadow-input-tag border border-gray-200">
                            <ColorPicker
                              value={toAntdColor(dismissIconColorRgba)}
                              onChange={(color) => {
                                const rgb = color.toRgb ? color.toRgb() : { r: 255, g: 255, b: 255, a: 1 };
                                const rgba = {
                                  r: rgb.r,
                                  g: rgb.g,
                                  b: rgb.b,
                                  a: rgb.a !== undefined ? rgb.a : 1,
                                };
                                setDismissIconColorRgba(rgba);
                                setDismissIconColor(color.toHexString ? color.toHexString() : "#FFFFFF");
                              }}
                              showText
                              format="rgba"
                              size="small"
                              presets={[
                                {
                                  label: "Presets",
                                  colors: [
                                    "rgba(255, 255, 255, 1)",
                                    "rgba(0, 0, 0, 1)",
                                    "rgba(92, 189, 32, 1)",
                                    "rgba(255, 0, 0, 1)",
                                    "rgba(0, 255, 0, 1)",
                                    "rgba(0, 0, 255, 1)",
                                  ],
                                },
                              ]}
                            />
                            <span className="text-xs text-gray-600 flex-1 text-left">
                              {rgbaToString(dismissIconColorRgba)}
                            </span>
                          </div>
                        </div>
                      </>
                    )}

                    {/* Start Date (IST) */}
                    <div className="mb-3">
                      <label
                        htmlFor="start_date"
                        className="block text-sm text-[#121212] font-medium mb-1.5"
                      >
                        Start Date (IST) & Time (Optional)
                      </label>
                      <input
                        id="start_date"
                        type="datetime-local"
                        value={startDate}
                        onChange={(e) => setStartDate(e.target.value)}
                        className="block w-full placeholder-gray-400/70 rounded-xl bg-white px-4 py-2 text-gray-700 shadow-input-tag text-sm"
                      />
                      <p className="text-xs text-gray-500 mt-1">
                        Banner will start showing from this date and time
                      </p>
                    </div>

                    {/* Expiry Date (IST) */}
                    <div className="mb-3">
                      <label
                        htmlFor="expiry_date"
                        className="block text-sm text-[#121212] font-medium mb-1.5"
                      >
                        Expiry Date (IST) & Time (Optional)
                      </label>
                      <input
                        id="expiry_date"
                        type="datetime-local"
                        value={expiryDate}
                        onChange={(e) => setExpiryDate(e.target.value)}
                        className="block w-full placeholder-gray-400/70 rounded-xl bg-white px-4 py-2 text-gray-700 shadow-input-tag text-sm"
                      />
                      <p className="text-xs text-gray-500 mt-1">
                        Banner will automatically expire after this date and time
                      </p>
                    </div>

                    {/* Published Status */}
                    <div>
                      <label className="flex items-center gap-2">
                        <input
                          type="checkbox"
                          checked={published}
                          onChange={(e) => setPublished(e.target.checked)}
                          className="w-4 h-4 rounded"
                        />
                        <span className="text-sm text-[#121212] font-medium">
                          Published
                        </span>
                      </label>
                      <p className="text-xs text-gray-500 mt-1 ml-6">
                        Only published banners will be shown to users
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Conditions Section - Full Width */}
              <div className="mt-6 w-full">
                <div className="flex flex-row justify-between items-center mb-3">
                  <h3 className="text-base font-semibold text-[#121212]">Conditions</h3>
                  <button
                    type="button"
                    onClick={addCondition}
                    className="px-3 py-1.5 bg-[#5CBD20] text-white rounded-lg text-sm font-medium hover:bg-[#4CA018]"
                  >
                    + Add Condition
                  </button>
                </div>

                {conditions.length === 0 ? (
                  <div className="text-gray-500 text-sm mb-4">
                    No conditions added. Click "Add Condition" to add one.
                  </div>
                ) : (
                  <div className="flex flex-col gap-4">
                    {/* Global "Combine conditions with:" selector - shown when there are 2+ conditions */}
                    {conditions.map((condition, index) => (
                      <React.Fragment key={condition.id}>
                        {/* Intermediate operator between conditions */}
                        {index > 0 && (
                          <div className="flex items-center justify-center my-2">
                            <div className="flex items-center gap-3 bg-gray-100 px-4 py-2 rounded-lg">
                              <Select
                                value={condition.logic || "and"}
                                onChange={(e) => {
                                  updateCondition(condition.id, "logic", e.target.value);
                                }}
                                width="130px"
                                height="32px"
                                fontSize="14px"
                              >
                                <option value="and">AND</option>
                                <option value="or">OR</option>
                              </Select>
                            </div>
                          </div>
                        )}
                        <div
                          className="border border-gray-200 rounded-xl p-3 bg-gray-50"
                        >
                          <div className="flex flex-row justify-between items-start mb-2">
                            <span className="text-sm font-medium text-gray-700">
                              Condition {index + 1}
                            </span>
                            <button
                              type="button"
                              onClick={() => removeCondition(condition.id)}
                              className="text-red-500 hover:text-red-700 text-xs font-medium"
                            >
                              Remove
                            </button>
                          </div>

                        <div className="flex flex-col gap-2">
                          {/* Condition Type */}
                          <div>
                            <label className="block text-xs text-[#121212] font-medium mb-1">
                              Field
                            </label>
                            <Select
                              placeholder="Select field"
                              value={condition.type}
                              onChange={(e) =>
                                updateCondition(condition.id, "type", e.target.value)
                              }
                            >
                              <option value="email">Email</option>
                              <option value="subscription">Subscription</option>
                              <option value="last_login">Last Login</option>
                            </Select>
                          </div>

                          {/* Email Condition Fields */}
                          {condition.type === "email" && (
                            <>
                              <div>
                                <label className="block text-xs text-[#121212] font-medium mb-1">
                                  Operator
                                </label>
                                <Select
                                  placeholder="Select operator"
                                  value={condition.operator}
                                  onChange={(e) =>
                                    updateCondition(
                                      condition.id,
                                      "operator",
                                      e.target.value
                                    )
                                  }
                                >
                                  <option value="is">is</option>
                                  <option value="is not">is not</option>
                                  <option value="contains">contains</option>
                                  <option value="not contains">not contains</option>
                                  <option value="ends with">ends with</option>
                                  <option value="starts with">starts with</option>
                                  <option value="not ends with">not ends with</option>
                                  <option value="not starts with">
                                    not starts with
                                  </option>
                                </Select>
                              </div>
                              <div>
                                <label className="block text-xs text-[#121212] font-medium mb-1">
                                  Value
                                </label>
                                <input
                                  type="text"
                                  value={condition.value}
                                  onChange={(e) =>
                                    updateCondition(
                                      condition.id,
                                      "value",
                                      e.target.value
                                    )
                                  }
                                  placeholder="Email value"
                                  className="block w-full placeholder-gray-400/70 rounded-3xl bg-white px-5 py-2.5 text-gray-700 shadow-input-tag"
                                  disabled={!condition.operator}
                                />
                              </div>
                            </>
                          )}

                          {/* Subscription Condition Fields */}
                          {condition.type === "subscription" && (
                            <div>
                              <label className="block text-xs text-[#121212] font-medium mb-1">
                                Subscription
                              </label>
                              <SelectMulti
                                isMulti
                                placeholder="Select subscriptions"
                                value={
                                  Array.isArray(condition.value)
                                    ? condition.value.map((val) => {
                                        const plan = PLANS.find((p) => p.id === val);
                                        return plan
                                          ? { value: plan.id, label: plan.label }
                                          : { value: val, label: val };
                                      })
                                    : condition.value
                                    ? [
                                        {
                                          value: condition.value,
                                          label:
                                            PLANS.find((p) => p.id === condition.value)
                                              ?.label || condition.value,
                                        },
                                      ]
                                    : []
                                }
                                onChange={(selectedOptions) => {
                                  const values = selectedOptions
                                    ? selectedOptions.map((opt) => opt.value)
                                    : [];
                                  updateCondition(condition.id, "value", values);
                                }}
                                options={PLANS.map((plan) => ({
                                  value: plan.id,
                                  label: plan.label,
                                }))}
                                className="react-select-container"
                                classNamePrefix="react-select"
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    borderRadius: "24px",
                                    minHeight: "42px",
                                    border: "1px solid #e5e7eb",
                                    boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
                                  }),
                                  multiValue: (base) => ({
                                    ...base,
                                    backgroundColor: "#f3f4f6",
                                    borderRadius: "12px",
                                  }),
                                  multiValueLabel: (base) => ({
                                    ...base,
                                    color: "#121212",
                                    fontSize: "14px",
                                  }),
                                  multiValueRemove: (base) => ({
                                    ...base,
                                    borderRadius: "0 12px 12px 0",
                                    "&:hover": {
                                      backgroundColor: "#e5e7eb",
                                      color: "#121212",
                                    },
                                  }),
                                }}
                              />
                            </div>
                          )}

                          {/* Last Login Condition Fields */}
                          {condition.type === "last_login" && (
                            <>
                              <div>
                                <label className="block text-xs text-[#121212] font-medium mb-1">
                                  Operator
                                </label>
                                <Select
                                  placeholder="Select operator"
                                  value={condition.operator}
                                  onChange={(e) =>
                                    updateCondition(
                                      condition.id,
                                      "operator",
                                      e.target.value
                                    )
                                  }
                                >
                                  <option value="before">before</option>
                                  <option value="after">after</option>
                                </Select>
                              </div>
                              <div>
                                <label className="block text-xs text-[#121212] font-medium mb-1">
                                  Date
                                </label>
                                <input
                                  type="date"
                                  value={condition.value}
                                  onChange={(e) =>
                                    updateCondition(
                                      condition.id,
                                      "value",
                                      e.target.value
                                    )
                                  }
                                  className="block w-full placeholder-gray-400/70 rounded-3xl bg-white px-5 py-2.5 text-gray-700 shadow-input-tag"
                                  disabled={!condition.operator}
                                />
                              </div>
                            </>
                          )}
                        </div>
                        </div>
                      </React.Fragment>
                    ))}
                  </div>
                )}
              </div>
            </div>

            <div className="px-7 flex justify-center items-center gap-6 mt-5">
              <button
                onClick={handleSave}
                className="px-3 py-[9px] text-left text-[16px] text-[#5CBD20] font-medium rounded-[20px] shadow-card-box-shadow border border-solid border-[#5CBD20]"
              >
                {isBannerUpdating ? (
                  <PulseLoader size={8}></PulseLoader>
                ) : (
                  isNew ? "Create" : "Update"
                )}
              </button>
              {!isNew && (
                <button
                  onClick={onOpen}
                  className="px-3 py-[9px] text-left text-[16px] text-[#DE1111] font-medium rounded-[20px] shadow-card-box-shadow border border-solid border-[#DE1111]"
                >
                  Delete
                </button>
              )}
              <Modal
                blockScrollOnMount={false}
                isOpen={isOpen}
                onClose={onClose}
                borderRadius="20px"
              >
                <ModalOverlay />
                <ModalContent>
                  <ModalCloseButton />
                  <ModalHeader
                    mt="20px"
                    textAlign="center"
                    fontSize="24px"
                    fontWeight="medium"
                  >
                    Delete Banner
                  </ModalHeader>
                  <ModalBody>
                    <Text
                      color="#121213"
                      textAlign="center"
                      fontWeight="normal"
                      fontSize="16px"
                      mb="1rem"
                    >
                      This will permanently delete the banner.
                    </Text>
                  </ModalBody>
                  <ModalFooter>
                    <Box width="100%" display="flex" justifyContent="center">
                      <Box
                        onClick={handleDelete}
                        as="button"
                        width="150px"
                        height="48px"
                        lineHeight="1.2"
                        px="8px"
                        borderRadius="20px"
                        fontSize="16px"
                        fontWeight="normal"
                        bg="#DE1111"
                        color="#ffffff"
                        mb="30px"
                        _focus={{
                          boxShadow:
                            "0px 70.8569px 51.2194px rgba(41, 72, 152, 0.037963), 0px 42.1092px 27.8569px rgba(41, 72, 152, 0.0303704), 0px 21.8644px 14.2119px rgba(41, 72, 152, 0.025)",
                        }}
                      >
                        {isBannerDeleting ? (
                          <PulseLoader size={8}></PulseLoader>
                        ) : (
                          "Delete"
                        )}
                      </Box>
                    </Box>
                  </ModalFooter>
                </ModalContent>
              </Modal>
          </div>
        </div>
      )}
      {loading && (
        <div className="flex justify-center items-center h-screen">
          <PulseLoader size={15} />
        </div>
      )}
    </>
  );
}

export default EditBanner;

